<script>
import resources from './resources'

export default {
  name: 'address-form',
  mixins: [resources]
}
</script>

<template lang="pug">
  page(icon='', title='Meus Locais')
    .col-xs-12.content
      .container-fluid
        .row
          medibook-alert-custom(
            :show='show',
            @close='show = false',
            title='Atenção',
            type='sa-error',
            message='Não foi possivel carregar a localização geográfica para este local.',
            :buttonsNext='nextStepButtonAfterSave')

          .col-xs-12.white-bg
            .row
              .col-xs-12
                div.col-sm-10
                  .form-group.cadastro-form
                    .row
                      .col-xs-12.col-sm-6
                        .form-group(:class="{'has-error is-empty': $v.address.label.$error}")
                          f-text(
                            label="Nome do Local",
                            placeholder="Casa, Escritório, Armazem, etc",
                            v-model="address.label",
                            name="label", :errors="errors['label']")
                          p.help-block(v-if='$v.address.label.$error')
                            strong(v-if='!$v.address.label.required')
                              | Campo obrigatório

                      .col-xs-12.col-sm-6
                        .form-group(:class="{'has-error is-empty': $v.address.zip.$error}")
                          f-zip(
                            label="CEP",
                            v-model="address.zip",
                            name="label",
                            :errors="errors['zip']",
                            @on-get-address="setAddress")
                          p.help-block(v-if='$v.address.zip.$error')
                            strong(v-if='!$v.address.zip.required')
                              | Campo obrigatório

                  .form-group
                    .row
                      .col-xs-12.col-sm-6
                        .form-group(:class="{'has-error is-empty': $v.address.street.$error}")
                          f-text(
                            label="Logradouro",
                            v-model="address.street",
                            name="street",
                            :errors="errors['street']")
                          p.help-block(v-if='$v.address.street.$error')
                            strong(v-if='!$v.address.street.required')
                              | Campo obrigatório

                      .col-xs-12.col-sm-6
                        .form-group(:class="{'has-error is-empty': $v.address.number.$error}")
                          f-text(
                            label="Número",
                            v-model="address.number",
                            name="number",
                            :errors="errors['number']",
                            :maxlength="6")
                          p.help-block(v-if='$v.address.number.$error')
                            strong(v-if='!$v.address.number.required')
                              | Campo obrigatório

                  .form-group
                    .row
                      .col-xs-12.col-sm-6
                        f-text(
                          label="Complemento",
                          v-model="address.complement",
                          name="complement",
                          :errors="errors['complement']")

                      .col-xs-12.col-sm-6
                        .form-group(:class="{'has-error is-empty': $v.address.district.$error}")
                          f-text(
                            label="Bairro",
                            v-model="address.district",
                            name="district",
                            :errors="errors['district']")
                          p.help-block(v-if='$v.address.district.$error')
                            strong(v-if='!$v.address.district.required')
                              | Campo obrigatório

                  .form-group
                    .row
                      .col-xs-12.col-sm-6
                        .form-group(:class="{'has-error is-empty': $v.address.city.$error}")
                          f-text(
                            label="Cidade",
                            v-model="address.city",
                            name="city",
                            :errors="errors['city']")
                          p.help-block(v-if='$v.address.city.$error')
                            strong(v-if='!$v.address.city.required')
                              | Campo obrigatório

                      .col-xs-12.col-sm-3
                        f-select-state(label="UF", v-model="address.state", name="state", :errors="errors['state']")
                      .col-xs-12.col-sm-3
                        f-select-yes-no(label="Correspondência", v-model="address.correspondence", name="correspondence", :errors="errors['correspondence']")
                  .buttons-wrapper
                    button.btn.cancel
                      router-link(:to="{name: 'settings.addresses.index'}")
                        span.icon 
                        |  Cancelar
                    button.btn.save(@click.prevent="doSave()")
                      span.icon 
                      |  Salvar Alterações
</template>



// WEBPACK FOOTER //
// src/app/settings/addresses/form/form.vue